<template>
  <v-alert type="error" class="form-errors" v-if="errors.length > 0">
    <slot v-if="$slots.default" />

    <template v-else>
      <v-list-item :key="i" class="no-hover-effect" density="comfortable" v-for="(error, i) in errors">
        <v-list-item-title data-testid="form-error-item" class="d-flex align-center">
          <v-icon>mdi-circle-small</v-icon>
          <slot name="error" :error="error" v-if="$slots.error" />
          <template v-else>{{ getError(error) }}</template>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-alert>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import { ViolationError } from '@console/types';

export default defineComponent({
  name: 'FormErrors',

  props: {
    errors: {
      type: Array as PropType<ViolationError[]>,
      required: false,
      default: () => [],
    },
  },

  setup() {
    const getError = (error: ViolationError) => {
      return typeof error === 'string' ? error : error.text;
    };

    return {
      getError,
    };
  },
});
</script>

<style lang="scss">
.form-errors {
  .v-alert__wrapper > .v-icon,
  .v-list-item-title {
    font-size: 0.875rem;
    white-space: break-spaces;
  }
}
</style>

<style lang="scss">
/* console-layer: important */
.form-errors {
  .v-alert__wrapper > .v-icon,
  .v-list-item-title {
    color: var(--v-on-error-container) !important;
  }
}
</style>
